import Header from "@/components/layout/Header";
import HeroSection from "@/components/home/HeroSection";
import HowItWorksSection from "@/components/home/HowItWorksSection";
import ProblemSolutionSection from "@/components/home/ProblemSolutionSection";
import DestinationsSection from "@/components/home/DestinationsSection";
import ProductDemoSection from "@/components/home/ProductDemoSection";
import BusinessDemoSection from "@/components/home/BusinessDemoSection";
import EmployeeCarouselSection from "@/components/home/EmployeeCarouselSection";
import TestimonialsSection from "@/components/home/TestimonialsSection";
import StatsSection from "@/components/home/StatsSection";
import FinalCTASection from "@/components/home/FinalCTASection";
import { SEO } from "@/components/seo/SEO";
import { StructuredData, organizationSchema, websiteSchema, softwareApplicationSchema } from "@/components/seo/StructuredData";

const Home = () => {
  return (
    <>
      <SEO 
        title="Télétravail international & workation pour entreprises | Renest"
        description="Offrez à vos équipes la liberté de télétravailler à l'étranger 1 à 5 mois. Renest gère la logistique, vous pilotez les points et les demandes depuis un dashboard."
        canonical="https://renest.fr/"
      />
      <StructuredData data={[organizationSchema, websiteSchema, softwareApplicationSchema]} />
      
      <Header />
      <div className="min-h-screen bg-background pt-16">
      
      {/* 1. Hero Section */}
      <HeroSection />
      
      {/* 2. How It Works Section */}
      <HowItWorksSection />
      
      {/* 3. Problem/Solution Section */}
      <ProblemSolutionSection />
      
      {/* 4. Destinations Section */}
      <DestinationsSection />
      
      {/* 5. Product Demo Section */}
      <ProductDemoSection />
      
      {/* 6. Business Demo Section */}
      <section className="py-16 sm:py-24 px-4 bg-muted/30">
        <div className="container mx-auto">
          <BusinessDemoSection />
        </div>
      </section>
      
      {/* 7. Employee Carousel Section */}
      <EmployeeCarouselSection />
      
      {/* 8. Testimonials Section */}
      <section className="py-16 sm:py-24 px-4 bg-muted/30">
        <div className="container mx-auto">
          <div className="text-center mb-12 sm:mb-16">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground mb-4 sm:mb-6">
              Ils transforment déjà leur approche RH
            </h2>
            <p className="text-lg sm:text-xl text-muted-foreground max-w-3xl mx-auto leading-relaxed px-4">
              Découvrez comment des entreprises visionnaires utilisent RENEST 
              pour révolutionner leurs avantages employés.
            </p>
          </div>
          <TestimonialsSection />
        </div>
      </section>
      
      {/* 9. Stats Section */}
      <StatsSection />
      
      {/* 10. Final CTA Section */}
      <FinalCTASection />
      </div>
    </>
  );
};

export default Home;